import { Injectable } from '@angular/core';
import { ResourceEffect } from '@app/core/store/effects/resource.effect';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { State } from '@dwo/reducers';
import { Observable } from 'rxjs';
import { SiteService } from '@app/core/services/site.service';
import {
  AddSite,
  GetSite,
  GetSiteSuccess,
  LoadSites,
  LoadSitesSuccess,
  SiteActionTypes,
  UpdateSite,
  UpdateSiteSuccess,
} from '@app/core/store/actions/site.action';

@Injectable()
export class SiteEffect extends ResourceEffect {
  constructor(
    readonly actions$: Actions,
    readonly siteService: SiteService,
    readonly store: Store<State>,
  ) {
    super(actions$, siteService, store);
  }

  loadSites$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<LoadSites>(SiteActionTypes.LoadSites),
        this.fetchResource('loadSites', LoadSitesSuccess),
      ),
  );

  addSite$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<AddSite>(SiteActionTypes.AddSite),
        this.fetchResource('addSite', LoadSites, (action: AddSite) => [action.site]),
      ),
  );

  getSite$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<GetSite>(SiteActionTypes.GetSite),
        this.fetchResource('getSite', GetSiteSuccess, (action: GetSite) => [action.siteId]),
      ),
  );

  updateSite$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<UpdateSite>(SiteActionTypes.UpdateSite),
        this.fetchResource('updateSite', UpdateSiteSuccess, (action: UpdateSite) => [action.site]),
      ),
  );

  updateSiteSuccess$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<UpdateSiteSuccess>(SiteActionTypes.UpdateSiteSuccess),
        this.fetchResource('loadSites', LoadSitesSuccess),
      ),
  );
}
